class Swiper {
  constructor(trigger, object, positions, finishCallback) {
    this.object = object;
    this.trigger = trigger;
    this.mouseEnabled = true;
    this.trigger.on('mousedown', this.initDrag, this, false);
    this.trigger.on('pressmove', this.drag, this, false);
    this.trigger.on('pressup', this.finishDrag, this, false);

    this.callback = finishCallback;
    this.currentDistance = 0;
    this.startDrag = 0;
    this.dragDistance = 0;
    this.positions = [];

    let min = 0;
    let max = 0;
    positions.forEach((offset, i) => {
      this.positions.push({ offset: -offset, index: i });
      min = Math.min(offset, min);
      max = Math.max(offset, max);
    });
    this.totalDistance = max - min;
    this.currentPos = this.positions['0'];

    this.hasHideables = false;
    this.leftStop = this.positions[0].offset;
    this.rightStop = this.positions[this.positions.length - 1].offset;
  }

  attachHideables(hideables) {
    if (hideables.length) {
      if (hideables.length === this.positions.length) {
        this.positions.forEach((pos, index) => {
          pos.hideable = hideables[index];
        });
        this.hasHideables = true;
      }
    }
  }

  finishDrag(event) {
    event.stopPropagation();
    if (!this.mouseEnabled) return;
    this.checkPosTransitions();
  }

  initDrag(event) {
    event.stopPropagation();
    if (!this.mouseEnabled) return;
    this.startDrag = event.stageX;
    this.startPos = this.object.x;
    this.dragDistance = 0;
    this.setVisibles();
  }

  drag(event) {
    event.stopPropagation();
    if (!this.mouseEnabled) return;
    this.dragDistance = event.stageX - this.startDrag;
    this.endPos = this.startPos + this.dragDistance;
    this.object.x = this.endPos.clamp(this.rightStop, this.leftStop);
  }

  checkPosTransitions() {
    const changeThresh = 0.2;
    const change = this.dragDistance / (this.totalDistance / this.positions.length);
    if (Math.abs(change) < changeThresh) {
      console.info(`Recentering Pos${this.object.toString()}`);
      this.recenterPos();
    } else if (Math.sign(change) === 1) {
      console.info(`Sliding to Prev Pos${this.object.toString()}`);
      this.slideToPrevPos();
    } else {
      console.info(`Sliding to Next Pos${this.object.toString()}`);
      this.slideToNextPos();
    }
  }

  slideToNextPos() {
    if (this.currentPos.index < this.positions.length - 1) {
      const location = -this.positions[this.currentPos.index + 1].offset;
      this.slideTo(location, this.changeToNextPos.bind(this));
    }
  }

  changeToNextPos() {
    if (this.currentPos.index < this.positions.length - 1) {
      this.currentPos = this.positions[this.currentPos.index + 1];
    }
    this.object.x = -this.currentPos.offset;
  }

  setVisibles(start = 0, end = 0) {
    if (!this.hasHideables) return;
    this.positions.forEach(pos => {
      if (start !== 0 || end !== 0) {
        const min = Math.min(start, end);
        const max = Math.max(start, end);
        if (pos.index > min - 2 && pos.index < max + 2) {
          pos.hideable.visible = true;
        } else {
          pos.hideable.visible = false;
        }
      } else {
        const d = pos.index - this.currentPos.index;
        if (Math.abs(d) > 2) {
          pos.hideable.visible = false;
        } else {
          pos.hideable.visible = true;
        }
      }
    });
  }

  changeToPrevPos() {
    if (this.currentPos.index > 0) {
      this.currentPos = this.positions[this.currentPos.index - 1];
    }
    this.object.x = -this.currentPos.offset;
  }

  slideToPrevPos() {
    if (this.currentPos.index > 0) {
      const location = -this.positions[this.currentPos.index - 1].offset;
      this.slideTo(location, this.changeToPrevPos.bind(this));
    }
  }

  slideToPos(index) {
    this.setVisibles(this.currentPos.index, index);
    const location = -this.positions[index].offset;
    this.slideTo(location, () => {
      this.currentPos = this.positions[index];
      this.setVisibles();
    });
  }

  home() {
    this.slideToPos(0);
  }

  slideTo(location, callback) {
    this.dest = this.object.x;
    createjs.Tween.get(this, { override: true })
      .to({ dest: -location }, 500, createjs.Ease.quadOut)
      .call(() => {
        callback();
        this.callback();
      })
      .addEventListener('change', () => {
        this.object.x = this.dest;
      });
  }

  recenterPos() {
    const location = -this.currentPos.offset;
    this.slideTo(location, () => {});
  }
}

export { Swiper as default };
